module.exports = __webpack_public_path__ + "img/kubitan-34x73.cdcf1711.jpg";